import RestoreSession from './RestoreSession';
import { connect } from 'react-redux';
import { setActiveTab, setActivePerspective } from 'src/pages/NavigationShell/NavigationShell.slice';
import { asyncGetPlanDates } from '../AssortmentScopeSelector/AssortmentScopeSelector.actions';
import { receiveFilterState, updateFilterSelectionsFromServer } from '../FilterPanel/FilterPanel.slice';
import { Scope, FilterGroup } from 'src/types/Scope';
import { SelectionOverride } from 'src/common-ui/components/Filters/Filters';
import { BoundEnabledPerspective } from 'configuration-schemas/bindings.types';
import type { AppThunkDispatch } from 'src/store.types';
import { receiveScopeRefreshTrigger, requestScope } from '../AssortmentScopeSelector/AssortmentScopeSelector.slice';
import { withRouter, WithRouterProps } from '../higherOrder/withRouter';

interface RestoreSessionDispatchProps {
  setPerspective(perspective: BoundEnabledPerspective): void;
  setActiveTab(tab: string): void;
  requestScope(): void;
  receiveScope(scope: Scope): void;
  receiveFilters(filters: FilterGroup[]): void;
  setFilterSelections(filters: SelectionOverride[]): void;
  setTab(tab: string): void;
}

export interface RestoreSessionState {
  loading: boolean;
}

export interface RestoreSessionProps extends RestoreSessionDispatchProps, WithRouterProps {}

function mapDispatchToProps(dispatch: AppThunkDispatch): RestoreSessionDispatchProps {
  return {
    setPerspective(perspective: BoundEnabledPerspective) {
      dispatch(setActivePerspective(perspective));
    },
    setActiveTab(tab: string) {
      dispatch(setActiveTab(tab));
    },
    requestScope() {
      dispatch(requestScope());
    },
    receiveScope(scope: Scope) {
      const scopeObj = { scope: scope, updatedAt: Date.now() };
      dispatch(asyncGetPlanDates());
      dispatch(receiveScopeRefreshTrigger(scopeObj));
    },
    receiveFilters(filters: FilterGroup[]) {
      dispatch(receiveFilterState({ filters: filters, updatedAt: Date.now() }));
    },
    setFilterSelections(filters: SelectionOverride[]) {
      dispatch(updateFilterSelectionsFromServer(filters));
    },
    setTab(tab: string) {
      dispatch(setActiveTab(tab));
    },
  };
}
export default connect(null, mapDispatchToProps)(withRouter(RestoreSession));
